module.exports = __webpack_public_path__ + "img/mfrags.5dfd7c76.png";